import { TipoComunicado } from "./types";

export type EditTipoComunicadoProperty =
  | "SET_TIPO_COMUNICADO"
  | "UNSET_TIPO_COMUNICADO"
  | "SET_NOME"
  | "SET_CODIGO"
  | "SET_ATIVO";

export const INITIAL_STATE = {
  nomeTipoComunicado: "",
  codigoTipoComunicado: "",
  flagAtivo: false,
};

export function reducer(
  state: TipoComunicado,
  { type, payload }: { type: EditTipoComunicadoProperty; payload?: any }
): any {
  switch (type) {
    case "SET_TIPO_COMUNICADO":
      return {
        ...payload,
      };
    case "UNSET_TIPO_COMUNICADO":
      return undefined;
    case "SET_NOME":
      return {
        ...state,
        nomeTipoComunicado: payload,
      };
    case "SET_CODIGO":
      return {
        ...state,
        codigoTipoComunicado: payload,
      };
    case "SET_ATIVO":
      return {
        ...state,
        flagAtivo: payload,
      };
    default:
      return state;
  }
}
